<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="linespace"> </p>
<p class="DED-Dedication-text-Full-out"><span class="epub-sc">FOR JONNY, TIL DEATH US DO PART</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5c97902e